import React from 'react'

//* utils
import * as env from '../../../../constants/environment.constants'
import {
  availableLocaleTags,
  homepageTags,
  paginatedTags,
  prodEnvironmentTags,
  seoTags,
} from './addToDynamicTags'

//* tags
import {
  defaultDescriptionTag,
  defaultLang,
  defaultOGDescription,
  defaultOGImage,
  defaultOGTitle,
  defaultRobotsTag,
  defaultTitleTag,
  defaultTwitterDescription,
  defaultTwitterImage,
  defaultTwitterTitle,
} from './tags'

export const getDynamicTag = (
  seoData: any,
  canonicalURL: string,
  isPaginated: boolean,
  pageNum: number,
  isLastPage: boolean,
  hrefForPage: any,
  siteSection: string,
  pageSlug: string,
  availableLocales: any,
  URL: string,
  locale: string
) => {
  const environment = process.env.GATSBY_ENVIRONMENT

  const dynamicSEOTags: any = [
    defaultRobotsTag,
    defaultDescriptionTag,
    defaultOGDescription,
    defaultTwitterDescription,
    defaultTitleTag,
    defaultOGTitle,
    defaultTwitterTitle,
    defaultOGImage,
    defaultTwitterImage,
    defaultLang,
  ]

  if (environment !== env.ENVIRONMENT_MASTER) {
    dynamicSEOTags[0] = <meta name="robots" content="noindex, nofollow" key="robots-tag" />
  } else if (seoData.metaRobotsTag) {
    dynamicSEOTags[0] = <meta name="robots" content={seoData.metaRobotsTag} key="robots-tag" />
  }

  //* functions to populate dynamic tags
  seoTags(dynamicSEOTags, seoData, isPaginated, pageNum, locale)
  if (siteSection === 'Homepage') homepageTags(dynamicSEOTags)
  if (environment === env.ENVIRONMENT_MASTER) {
    prodEnvironmentTags(dynamicSEOTags, seoData, canonicalURL)
  }
  if (isPaginated && pageNum) paginatedTags(dynamicSEOTags, pageNum, hrefForPage, isLastPage)
  availableLocaleTags(dynamicSEOTags, siteSection, pageSlug, availableLocales, URL)

  return dynamicSEOTags
}
